import { render, staticRenderFns } from "./FuncionarioNavigation.vue?vue&type=template&id=327a37dc&"
import script from "./FuncionarioNavigation.vue?vue&type=script&lang=js&"
export * from "./FuncionarioNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports